/**
 * Common Zod primitives reused across module schemas.
 * See docs/product/backend/04-validation-zod.md.
 */

import { z } from 'zod';

export const UlidSchema = z.string().regex(/^[0-9A-HJKMNP-TV-Z]{26}$/i, 'must be ULID');
export const UidSchema = z.string().min(1).max(128);
export const IsoTsSchema = z.string().datetime();
export const IsoDateSchema = z.string().regex(/^\d{4}-\d{2}-\d{2}$/, 'must be YYYY-MM-DD');
export const InrAmountSchema = z.number().positive().multipleOf(0.01).max(10_000_000);
export const CurrencySchema = z.literal('INR');

export const PaginationQuerySchema = z.object({
  limit: z.coerce.number().int().min(1).max(200).optional(),
  offset: z.coerce.number().int().min(0).optional(),
});

export const IndianPhoneSchema = z
  .string()
  .regex(/^(\+91)?[6-9]\d{9}$/, 'invalid Indian phone');
export const Pincode6Schema = z.string().regex(/^\d{6}$/, 'must be 6-digit pincode');
export const IfscSchema = z.string().regex(/^[A-Z]{4}0[A-Z0-9]{6}$/, 'invalid IFSC');
export const VpaSchema = z.string().regex(/^[\w.\-]{2,256}@[a-zA-Z]{2,64}$/, 'invalid VPA');
export const AadhaarSchema = z.string().regex(/^\d{12}$/, 'must be 12 digits');
export const PanSchema = z.string().regex(/^[A-Z]{5}\d{4}[A-Z]$/, 'invalid PAN');

export type Pagination = z.infer<typeof PaginationQuerySchema>;
